import { Button, Dropdown } from "@components/index";
import type { AppRoutes } from "@routes/hooks/useSafeNavigate";
import { useSafeNavigate } from "@routes/hooks/useSafeNavigate";
import type React from "react";

type Props = {
  close: () => void;
};

const HeaderButtonReport: React.FC<Props> = ({ close }) => {
  const navigate = useSafeNavigate();

  const goTo = (route: AppRoutes) => {
    close();
    void navigate(route);
  };

  const trigger = (
    <Button
      blockedWidth
      size="lg"
      content="start"
      buttonStyle="tertiary"
      icon="report"
      label="Relatórios"
    />
  );

  return (
    <Dropdown position="left" trigger={trigger}>
      {() => (
        <>
          <Button
            blockedWidth
            size="lg"
            content="start"
            buttonStyle="tertiary"
            icon="report"
            label="Relatório gerencial"
            onClick={() => goTo("/management-report")}
          />
        </>
      )}
    </Dropdown>
  );
};

export default HeaderButtonReport;
